<template>
  <div class="vue__form-input-item">
    <div class="vue__form-input-wrapper">
      <div class="vue__form-input-icon">
        <slot name="icon"></slot>
      </div>
      <input
        ref="input"
        v-bind="$attrs"
        v-on="listeners"
        :value="value"
        :class="{ 'has-icon': $slots.icon, 'has-error': shouldShowError }"
        class="vue__form-input"
        type="text"
      />

      <div v-if="shouldShowValidationIcon" class="vue__form-input-validation-icon">

        <transition name="fade-slide" mode="out-in">
          <FaIcon v-if="error" icon="times" :key="0" />
          <FaIcon v-else icon="check" :key="1" />
        </transition>
      </div>
    </div>

    <ErrorWrapper v-if="shouldShowError">
      {{error}}
    </ErrorWrapper>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    inheritAttrs: false,

    props: {
      value: true,

      error: {
        type: String,
        default: ''
      },

      forceValidate: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        validated: false
      };
    },

    computed: {
      ...mapState(['authenticated']),

      listeners () {
        return {
          ...this.$listeners,
          input: event => this.$emit('input', event.target.value),
          blur: () => this.validated = true
        };
      },

      shouldShowValidationIcon () {
        return this.validated;
      },

      shouldShowError() {
        return (this.validated || this.forceValidate) && this.error
      }
    },

    watch: {
      authenticated() {
        this.validated = false;
      }
    }
  };
</script>

<style
  scoped
  lang="scss"
>
  .vue__form-input-item {
    margin-bottom: 10px;
  }

  .vue__form-input-wrapper {
    position: relative;
  }

  .vue__form-input {
    width: 100%;
    padding: 10px 16px;
    border-radius: 4px;
    border: 2px solid #ccc;

    &, &:focus {
      outline: 0;
    }

    &[readonly] {
      background: #f3f3f3;
    }

    &.has-icon {
      padding-left: 32px;
    }

    &.has-error {
      border: 2px solid #ff5d33 !important;
      outline: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    &::placeholder {
      color: #999;
      opacity: .5;
      transition: opacity .2s;
    }

    &:hover::placeholder {
      opacity: 1;
    }
  }

  .vue__form-input-icon {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
  }

  .vue__form-input-validation-icon {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    .fa-check {
      color: limegreen;
    }

    .fa-times {
      color: red;
    }
  }
</style>